import { Component, OnInit } from '@angular/core';
import { SmsWidgetComponent } from '../../sms-widget/sms-widget.component';
import { Router } from '@angular/router';
import { UtilsService, ClientService, ModalService } from '@app/services';
import { I18nPipe } from '@app/shared/pipes/i18n.pipe';

@Component({
  selector: 'app-sms-widget-vertical',
  templateUrl: './sms-widget-vertical.component.html',
  styleUrls: ['./sms-widget-vertical.component.css']
})
export class SmsWidgetVerticalComponent extends SmsWidgetComponent implements OnInit {

  constructor(
    protected clientService: ClientService,
    protected router: Router,
    protected utils: UtilsService,
    protected i18n: I18nPipe,
    protected modalService: ModalService
  ) {
    super(clientService, router, utils, i18n, modalService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
